



























import CollapsibleGroup from '@/edinet/components/CollapsibleGroup.vue'
import {groupBy} from "@/edinet/libs/utils";
import SelectDocsFilter from "@/edinet/search2/SelectDocsFilter.vue";
import {EdinetDocIndexCli} from "@/edinet/store_edinet";
import {filterEdinetDocIndexByDocType} from "@/edinet/viewer/ViewerHelper";
import dayjs from "dayjs";
import Vue, {PropType} from 'vue'

const instance = Vue.extend({
  components: {CollapsibleGroup, SelectDocsFilter},
  props: {
    edinetDocs: {
      type: Array as PropType<Array<EdinetDocIndexCli>>,
      default: []
    }
  },
  data() {
    return {docsFilter: 'Relevant'}
  },
  computed: {
    displayResults(): EdinetDocIndexCli[] {
      return filterEdinetDocIndexByDocType(this.edinetDocs, this.docsFilter)
    },
    search2ResultsCount(): string {
      return this.displayResults.length + '/' + this.edinetDocs.length
    },
    groupedIndices(): Array<[number, EdinetDocIndexCli[]]> {
      const g = groupBy(this.displayResults, x => dayjs(x.date).year())
      const l = Array.from(g.entries()).sort((x, y) => y[0] - x[0])
      return l
    }
  },
  filters: {
    dateFilter: function(date: string) {
      return dayjs(date).format('MM/DD')
    }
  }
})

export default instance
